import React, { Component } from 'react';
import { Popover, Typography, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import reviewData from '../../../reviewData';
import "./styles.scss";

const styles = theme => ({
    typography: {
        padding: theme.spacing(1),
    },
    popover: {
        pointerEvents: 'none',
        boxShadow: "none"
    },
    paper: {
        padding: theme.spacing(1),
        outline: "none",
        boxShadow: "1px -0.5px 0 #eee, 1px -0.5px 2px #ccc"
    },
    popWord: {
        textAlign: "center",
        color: "darkgreen",
        fontWeight: "700",
        fontSize: "18px"
    }
});

class StoryText extends Component {
    constructor(props) {
        super(props);

        this.state = {
            storySegment: {},
            analysis: {},
            index: this.props.index,
            fadeToggle: this.props.fadeToggle,
            fadeProp: null,
            textAnalysis: null,
            wordScore: []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.fadeToggle !== this.state.fadeToggle) {
            this.setState({ fadeToggle: nextProps.fadeToggle, fadeProp: "fade-out" })
        }
        if (nextProps.index !== this.state.index) {
            this.setState({ index: nextProps.index, fadeProp: "fade-in" });
        }
    }

    textOverlay = (index, e) => {
        this.props.analysis &&
            this.props.analysis.NBest &&
            this.setState({
                textAnalysis: e.currentTarget, wordScore: this.props.analysis.NBest[0].Words[index]
            });
    }

    closeTextOverlay = () => {
        this.setState({ textAnalysis: null });
    }

    render() {
        const open = Boolean(this.state.textAnalysis);
        const { analysis, classes, reviewIndex, highlightWordIndex, playComputerVoice, paraSegments, paraSegmentsIndex } = this.props;
        const storyWordList = this.props.storyWordList;
        var analysisWords = [];
        analysisWords = analysis && analysis.NBest && analysis.NBest[0].Words;

        if (storyWordList) {
            return (
                <div style={{ maxHeight: "-webkit-fill-available" }}>
                    {
                        <div>
                            {Array.isArray(storyWordList) && storyWordList.map((value, index) => {
                                let style = { fontSize: "calc( 1.5em + (24 - 16) * (100vw - 400px) / (800 - 400) )" };
                                if (analysisWords && analysisWords.length > 0) {
                                    let analysisWord = analysisWords[index];
                                    style = analysisWord &&
                                        analysisWord.AccuracyScore < 60 ?
                                        { fontWeight: 'bold', fontSize: "calc( 1.5em + (24 - 16) * (100vw - 400px) / (800 - 400) )" } :
                                        { fontSize: "calc( 1.5em + (24 - 16) * (100vw - 400px) / (800 - 400) )" }
                                }
                                return (
                                    <span key={index}>
                                        <span id='textToPlay'
                                            className={
                                                `${this.state.fadeProp} ${(this.props.playRecording || this.props.playComputer) && (highlightWordIndex === index) && "highlight"}`
                                            }
                                            aria-owns={open ? 'mouse-over-popover' : undefined}
                                            aria-haspopup="true"
                                            onMouseEnter={(e) => { this.textOverlay(index, e) }}
                                            onMouseLeave={this.closeTextOverlay}
                                            style={style}>{value} </span>

                                        <Popover
                                            id='mouse-over-popover'
                                            open={open}
                                            className={classes.popover}
                                            classes={{
                                                paper: classes.paper,
                                            }}
                                            anchorEl={this.state.textAnalysis}
                                            onClose={this.closeTextOverlay}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                            disableRestoreFocus
                                        >
                                            <Typography className={classes.popWord}>
                                                {this.state.wordScore && this.state.wordScore.Word &&
                                                    this.state.wordScore.Word}
                                            </Typography>
                                            <Divider style={{ background: "darkgreen" }} />
                                            <Divider style={{ background: "darkgreen" }} />
                                            <Typography className={classes.typography}>
                                                <span style={{ color: "red" }}>Accuracy:</span> {this.state.wordScore && this.state.wordScore.AccuracyScore &&
                                                    this.state.wordScore.AccuracyScore}
                                            </Typography>
                                            <Divider style={{ background: "darkblue" }} />
                                            <Typography className={classes.typography} style={{ color: "red" }}>
                                                Phonemes
                                            </Typography>
                                            {this.state.wordScore && this.state.wordScore.Phonemes &&
                                                this.state.wordScore.Phonemes.map((value, index) => {
                                                    return (
                                                        <Typography className={classes.typography} key={index}>
                                                            {value.Phoneme}: {value.AccuracyScore}
                                                        </Typography>
                                                    )
                                                })
                                            }
                                        </Popover>
                                    </span>)
                            })}
                        </div>
                    }
                </div>
            )
        } else {
            return null;
        }


    }
}

export default withStyles(styles, { withTheme: true })(StoryText);